export * from './heading.component';
